import {all, call, put, takeEvery} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/authActions';
import * as actions from '../actions/historyActions';

function* analyticsRequested({payload}) {
    try {
        const response = yield call(api.history, payload.nodeId, payload.propId, payload.params);
        yield put(actions.historySuccess(payload.id, response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.historyFailure(payload.id, error));
    }
}

export default function* root() {
    yield all([
        takeEvery(constants.HISTORY_REQUESTED, analyticsRequested),
    ]);
}
